import { chakra, Box, InputRightAddon } from "@chakra-ui/react";

export const Container = chakra(Box, {
  baseStyle: {
    w: "full",
    mt: 2
  }
});

export const SubmitButton = chakra(InputRightAddon, {
  baseStyle: {
    bg: "black",
    border: "none",
    borderEndRadius: "2px",
    cursor: "pointer",
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
    width: "40px",
    minWidth: "40px"
  }
});
